import App from './App.svelte';

function inIframe() {
	try {
		return window.self !== window.top || new URLSearchParams(window.location.search).get('action') === 'set-token';
	} catch (e) {
		return true;
	}
}

let app = null;
if (inIframe()) {
	window.addEventListener('message', (message) => {
		if (message.data.token) {
			localStorage.setItem('token', message.data.token);
		}
	});
} else {
	app = new App({ target: document.body, props: { iframe: false } });
}

function enterFullScreen() {
	if (!document.fullscreenElement) {
		document.body.requestFullscreen();
	}
}

const fullscreen = window.location.search.match(/[\?&]fullscreen=(\d+)/);
if (fullscreen && +fullscreen[1] > 0 && "requestFullscreen" in document.body && "fullscreenElement" in document) {
	document.body.addEventListener("click", enterFullScreen);
}

export default app;